export enum AccountType {
  BANK = 'BANK',
  CASH = 'CASH',
  MOBILE = 'MOBILE',
  MISC = 'MISC', //miscellaneous account
}
export enum Currency {
  XAF = 'XAF',
}

export enum CommonRecordLabel {
  INTERNAL_TRANSFER = 'Internal Transfer',
}

export const AccountTypeForAutomaticOperations = [
  AccountType.BANK,
  AccountType.MISC,
];
